import { createFileRoute } from '@tanstack/react-router'
import { PublicLayout } from '@/shell/PublicLayout'

/** Layout for signed-out pages (login, signup, legal, status…). */
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
})
